import { useLocale } from "../lib/i18n";

interface TelegramRequiredPageProps {
  title: string;
  message: string;
}

export function TelegramRequiredPage({
  title,
  message,
}: TelegramRequiredPageProps) {
  const { t } = useLocale();

  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-6">
      <div className="w-full max-w-sm rounded-3xl border border-gray-200 bg-white p-6 text-center shadow-sm">
        <div className="mb-3 text-2xl font-bold text-gray-900">{title}</div>
        <p className="text-sm leading-6 text-gray-500">{message}</p>
        <a
          href="https://t.me/mesterin_md_bot"
          target="_blank"
          rel="noreferrer"
          className="mt-6 inline-flex w-full items-center justify-center rounded-2xl bg-blue-600 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-blue-700"
        >
          {t.openBot}
        </a>
      </div>
    </div>
  );
}
